/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { vendorActionLogControllerCreate } from '../fn/vendor-action-log/vendor-action-log-controller-create';
import { VendorActionLogControllerCreate$Params } from '../fn/vendor-action-log/vendor-action-log-controller-create';
import { vendorActionLogControllerDelete } from '../fn/vendor-action-log/vendor-action-log-controller-delete';
import { VendorActionLogControllerDelete$Params } from '../fn/vendor-action-log/vendor-action-log-controller-delete';
import { vendorActionLogControllerFindAll } from '../fn/vendor-action-log/vendor-action-log-controller-find-all';
import { VendorActionLogControllerFindAll$Params } from '../fn/vendor-action-log/vendor-action-log-controller-find-all';
import { vendorActionLogControllerFindById } from '../fn/vendor-action-log/vendor-action-log-controller-find-by-id';
import { VendorActionLogControllerFindById$Params } from '../fn/vendor-action-log/vendor-action-log-controller-find-by-id';
import { vendorActionLogControllerSearchCursor } from '../fn/vendor-action-log/vendor-action-log-controller-search-cursor';
import { VendorActionLogControllerSearchCursor$Params } from '../fn/vendor-action-log/vendor-action-log-controller-search-cursor';
import { vendorActionLogControllerSearchOffset } from '../fn/vendor-action-log/vendor-action-log-controller-search-offset';
import { VendorActionLogControllerSearchOffset$Params } from '../fn/vendor-action-log/vendor-action-log-controller-search-offset';
import { vendorActionLogControllerUpdate } from '../fn/vendor-action-log/vendor-action-log-controller-update';
import { VendorActionLogControllerUpdate$Params } from '../fn/vendor-action-log/vendor-action-log-controller-update';
import { VendorActionLogDto } from '../models/vendor-action-log-dto';

@Injectable({ providedIn: 'root' })
export class VendorActionLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorActionLogControllerFindAll()` */
  static readonly VendorActionLogControllerFindAllPath = '/api/vendorActionLLog';

  /**
   * 입점사 로그 전체 조회.
   *
   * 입점사 로그 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorActionLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerFindAll$Response(params?: VendorActionLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorActionLogDto>>> {
    return vendorActionLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 로그 전체 조회.
   *
   * 입점사 로그 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorActionLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerFindAll(params?: VendorActionLogControllerFindAll$Params, context?: HttpContext): Observable<Array<VendorActionLogDto>> {
    return this.vendorActionLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorActionLogDto>>): Array<VendorActionLogDto> => r.body)
    );
  }

  /** Path part for operation `vendorActionLogControllerCreate()` */
  static readonly VendorActionLogControllerCreatePath = '/api/vendorActionLLog';

  /**
   * 입점사 로그 생성.
   *
   * 입점사 로그을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorActionLogControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorActionLogControllerCreate$Response(params: VendorActionLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorActionLogDto>> {
    return vendorActionLogControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 로그 생성.
   *
   * 입점사 로그을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorActionLogControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorActionLogControllerCreate(params: VendorActionLogControllerCreate$Params, context?: HttpContext): Observable<VendorActionLogDto> {
    return this.vendorActionLogControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorActionLogDto>): VendorActionLogDto => r.body)
    );
  }

  /** Path part for operation `vendorActionLogControllerSearchOffset()` */
  static readonly VendorActionLogControllerSearchOffsetPath = '/api/vendorActionLLog/search/offset';

  /**
   * 입점사 로그 오프셋 기반 조회.
   *
   * 입점사 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorActionLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerSearchOffset$Response(params: VendorActionLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return vendorActionLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 로그 오프셋 기반 조회.
   *
   * 입점사 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorActionLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerSearchOffset(params: VendorActionLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.vendorActionLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorActionLogControllerSearchCursor()` */
  static readonly VendorActionLogControllerSearchCursorPath = '/api/vendorActionLLog/search/cursor';

  /**
   * 입점사 로그 커서 기반 조회.
   *
   * 입점사 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorActionLogControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerSearchCursor$Response(params: VendorActionLogControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return vendorActionLogControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 로그 커서 기반 조회.
   *
   * 입점사 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorActionLogControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerSearchCursor(params: VendorActionLogControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.vendorActionLogControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorActionLogControllerFindById()` */
  static readonly VendorActionLogControllerFindByIdPath = '/api/vendorActionLLog/{id}';

  /**
   * 입점사 로그 ID 기반 조회.
   *
   * 입점사 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorActionLogControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerFindById$Response(params: VendorActionLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorActionLogDto>> {
    return vendorActionLogControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 로그 ID 기반 조회.
   *
   * 입점사 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorActionLogControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerFindById(params: VendorActionLogControllerFindById$Params, context?: HttpContext): Observable<VendorActionLogDto> {
    return this.vendorActionLogControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorActionLogDto>): VendorActionLogDto => r.body)
    );
  }

  /** Path part for operation `vendorActionLogControllerDelete()` */
  static readonly VendorActionLogControllerDeletePath = '/api/vendorActionLLog/{id}';

  /**
   * 입점사 로그 삭제.
   *
   * 입점사 로그을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorActionLogControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerDelete$Response(params: VendorActionLogControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorActionLogDto>> {
    return vendorActionLogControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 로그 삭제.
   *
   * 입점사 로그을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorActionLogControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorActionLogControllerDelete(params: VendorActionLogControllerDelete$Params, context?: HttpContext): Observable<VendorActionLogDto> {
    return this.vendorActionLogControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorActionLogDto>): VendorActionLogDto => r.body)
    );
  }

  /** Path part for operation `vendorActionLogControllerUpdate()` */
  static readonly VendorActionLogControllerUpdatePath = '/api/vendorActionLLog/{id}';

  /**
   * 입점사 로그 수정.
   *
   * 입점사 로그을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorActionLogControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorActionLogControllerUpdate$Response(params: VendorActionLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorActionLogDto>> {
    return vendorActionLogControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 로그 수정.
   *
   * 입점사 로그을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorActionLogControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorActionLogControllerUpdate(params: VendorActionLogControllerUpdate$Params, context?: HttpContext): Observable<VendorActionLogDto> {
    return this.vendorActionLogControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorActionLogDto>): VendorActionLogDto => r.body)
    );
  }

}
